import {Link as LinkType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/link.types';
import {useHistory, useQueryParams} from '@aboutyou/router';
import {useTrackFeature} from '@aboutyou/tracking';
import {
  COLORS,
  GenericIconName,
  Heading18,
  Icon,
  UnstyledLink,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';

interface HelpCenterMobileNavigationProps {
  breadcrumbs: LinkType[];
  hideTitle?: boolean;
}

export const HelpCenterMobileNavigation = ({
  breadcrumbs: links,
  hideTitle = false,
}: HelpCenterMobileNavigationProps) => {
  const currentSection = links[links.length - 1];
  const previousSection = links[links.length - 2];
  const trackFeature = useTrackFeature();
  const {push} = useHistory();
  const queryParams = useQueryParams();
  const isFromHCLandingPage = queryParams.get('fromHCLandingPage');

  // NOTE: this should never happen, but we do it just in case, and to ensure correct typing below
  if (currentSection == null || previousSection == null) {
    return null;
  }

  const previousPageUrl = hideTitle
    ? currentSection.linkTarget.url
    : previousSection.linkTarget.url;

  const handleBacklinkClick = () => {
    trackFeature({eventType: 'click', label: 'self_service_flow_back'});
  };

  return (
    <Container $noBorder={hideTitle}>
      {isFromHCLandingPage ? (
        <Icon
          asset={GenericIconName.ArrowLeft}
          size="M"
          onClick={() => {
            handleBacklinkClick();
            push('/h');
          }}
        />
      ) : (
        <UnstyledLink
          onClick={handleBacklinkClick}
          to={previousPageUrl}
          aria-label={undefined}
        >
          <Icon asset={GenericIconName.ArrowLeft} size="M" />
        </UnstyledLink>
      )}
      {!hideTitle && (
        <TitleContainer>
          <Title>{currentSection.label}</Title>
        </TitleContainer>
      )}
    </Container>
  );
};

export const Container = styled.div<{$noBorder?: boolean}>`
  padding: 20px;
  padding-right: 50px;
  background: ${COLORS.White};
  display: flex;
  align-items: center;
  border-bottom: ${({$noBorder}) =>
    $noBorder ? 'none' : css`1px solid ${COLORS.Grey3}`};
`;

const TitleContainer = styled.div`
  flex: 1;
  text-align: center;
  margin-left: 5px;
  display: flex;
  min-width: 0;
`;

const Title = styled(Heading18)`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 2rem;
`;
